export const createGetHookExamplesRequest = () => {
  return {
      url: "/hooks/examples",
      method: "GET",
      data: {},
  };
}